<template>
  <div class="view-details" :class="{ 'view-details': true, show: show }">
    <div class="flex flex-v-center flex-h-bet">
      <h3 class="bold blue">LEAVE TYPE SETTING DETAILS</h3>
      <img
        src="/img/circle-x.svg"
        alt="close"
        class="pointer"
        @click="$emit('toggleView')"
      />
    </div>
    <div class="view-details-body mt-20">
      <h3 class="bold">ID NO</h3>
      <div class="view-details-item">
        <p>{{ leaveType.id }}</p>
      </div>
      <hr class="hr" />
      <h3 class="bold mt-5">LEAVE TYPE</h3>
      <div class="view-details-item">
        <p>{{ leaveType.leave_name }}</p>
      </div>
      <hr class="hr" />
      <h3 class="bold mt-5">NO OF DAYS</h3>
      <div class="view-details-item">
        <p>{{ leaveType.applicable_days }}</p>
      </div>
      <hr class="hr" />
      <h3 class="bold mt-5">PAID LEAVE TYPE</h3>
      <div class="view-details-item">
        <p>{{ leaveType.is_paid === false ? "No" : "Yes" }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapState } = createNamespacedHelpers("admin/hrm/leave");

export default {
  props: ["show"],
  computed: {
    ...mapState({
      view: "showViewContainer",
      loading: "viewContainerLoading",
      leaveType: "currentLeaveType",
    }),
  },
};
</script>

<style>
.hr {
  width: calc(100% + 40px);
  margin-left: -20px;
  margin-top: 10px;
}

.mt-5 {
  margin-top: 5px;
}
</style>
